export default function CosmicBackground() {
  return (
    <>
      <div className="starfield" aria-hidden="true" />
      <div className="aurora" aria-hidden="true" />
    </>
  );
}
